<div class="flex flex-col justify-center flex-1 w-full max-w-md mx-auto">
    <div>
        <div class="mb-5 sm:mb-8">
            <h1 class="mb-2 font-semibold text-gray-800 text-title-sm dark:text-white/90 sm:text-title-md">
                Forgot Your Password?
            </h1>
            <p class="text-md text-gray-500 dark:text-gray-400">
                Enter the email address linked to your account, and we’ll send you a link to reset your password.
            </p>
        </div>

        <form [formGroup]="form" (ngSubmit)="onSubmit()" class="space-y-6">
            <div>
                <app-lable>Email <span class="text-error-500">*</span></app-lable>
                <app-input-field type="email" placeholder="info@gmail.com" formControlName="email"
                    [error]="!!fieldError('email')" [hint]="fieldError('email')" />
            </div>

            <app-button className="w-full" size="sm" (btnClick)="onSubmit()">
                Submit
            </app-button>
        </form>

        <div class="mt-5">
            <p class="text-md font-normal text-center text-gray-700 dark:text-gray-400 sm:text-start">
                Wait, I remember my password...
                <a routerLink="/login" class="text-brand-500 hover:text-brand-600 dark:text-brand-400">
                    Click here
                </a>
            </p>
        </div>
        <div *ngIf="success" class="mt-5 text-center bg-green-100 backdrop-blur-sm text-green-700 text-sm font-bold px-3 py-1.5 rounded-full shadow-sm">
            <span>
                Password reset link sent to your email.
            </span>
        </div>
    </div>
</div>